import { gql } from '@apollo/client';

const Fragments = {
  documentTypePropertyItem: gql`
    fragment documentTypePropertyItem on DocumentTypePropertyItem {
      documentTypeId
      propertyId
      propertyCode
      propertyName
      propertyTypeId
      mandatory
      defaultValue
      implicit
      orderNo
    }
  `,
  documentTypePropertyXState: gql`
    fragment documentTypePropertyXState on DocumentTypePropertyXState {
      documentTypeId
      propertyId
      documentStateId
      allowEdit
    }
  `
};

export default Fragments;
